module.exports = __webpack_public_path__ + "img/verified.6e0b4e5f.png";